const LOAD_STATES = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  READY: "ready",
  ERROR: "error",
  STALE: "stale",
});

function createIdleLoadMeta() {
  return {
    loadState: LOAD_STATES.IDLE,
    error: null,
    source: null,
    startedAt: null,
    endedAt: null,
    lastLoadedAt: null,
    requestKey: null,
  };
}

function startLoadMeta(requestKey = createRequestKey()) {
  return {
    ...createIdleLoadMeta(),
    loadState: LOAD_STATES.LOADING,
    startedAt: Date.now(),
    requestKey,
  };
}

function completeLoadMeta(previousMeta, result) {
  return {
    ...previousMeta,
    loadState: LOAD_STATES.READY,
    error: null,
    source: result?.source ?? "unknown",
    endedAt: result?.endedAt ?? Date.now(),
    lastLoadedAt: result?.endedAt ?? Date.now(),
  };
}

function failLoadMeta(previousMeta, error) {
  return {
    ...previousMeta,
    loadState: LOAD_STATES.ERROR,
    error,
    endedAt: Date.now(),
  };
}

function markLoadMetaStale(previousMeta) {
  return {
    ...previousMeta,
    loadState: LOAD_STATES.STALE,
  };
}

function createRequestKey(prefix = "req") {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export {
  LOAD_STATES,
  completeLoadMeta,
  createIdleLoadMeta,
  createRequestKey,
  failLoadMeta,
  markLoadMetaStale,
  startLoadMeta,
};
